import { YodaBorderRadius, YodaColors, YodaFontSize, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const dialogStyle = {
  '& .MuiDialog-paper': {
    justifyContent: YodaJustifyContent.spaceAround,
    padding: YodaSpacing.xxLarge,
    minWidth: '700px',
    minHeight: '600px',
    borderRadius: YodaBorderRadius.medium,
  },
};

export const titleStyle = {
  fontSize: YodaFontSize.xLarge,
};

export const dialogContentStyle = {
  marginTop: YodaSpacing.large,
  padding: 0,
};

export const dialogContentBoxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: YodaSpacing.medium,
  padding: YodaSpacing.xxSmall,
  fontSize: YodaFontSize.small,
};

export const listIconStyle = {
  paddingRight: YodaSpacing.xxSmall,
  fontSize: YodaFontSize.xSmall,
  opacity: 0.5,
};

export const loaderWrapperStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 5,
  alignItems: 'center',
  background: YodaColors.gray0,
  opacity: 0.75,
};
